import { type UseMutationResult, useMutation } from 'react-query';
import {
  MyHoldingsSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto,
} from '../../services/wealthlane-award-services';
import { handleDownloadFile } from '../../utils/global';

const usePostOptionAwardDownloadDocument = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setCardIndex: (value: number) => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto | undefined,
  unknown,
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto,
  unknown
> => {
  const getFileExtension = (filename: string): string => {
    if (!filename) return '';

    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) return '';

    return filename.substring(lastDotIndex + 1).toLowerCase();
  };
  return useMutation(
    // eslint-disable-next-line camelcase
    async (payload: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto) => {
      return await handleRequest(
        MyHoldingsSharedService.postApiAwardApiAppMyHoldingsDownloadDocument(payload)
      );
    },
    {
      // eslint-disable-next-line camelcase
      onSuccess: (data?: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto, payload?: any) => {
        const extension = getFileExtension(payload?.documentContentName ?? '');

        if (data !== undefined && data !== null) {
          // Check if data.name has an extension
          const dataNameExtension = getFileExtension(data.name ?? '');

          // If data.name doesn't have an extension, add the extension from payload
          let filename = data.name ?? '';
          if (!dataNameExtension && extension) {
            filename = `${data.name ?? ''}.${extension}`;
          }

          handleDownloadFile(filename, data.content ?? '');
          setCardIndex(0);
        }
      },
    }
  );
};

export default usePostOptionAwardDownloadDocument;
